<template>
    <div @click="handleOpen" class="md:hidden cursor-pointer p-2">
        <ion-icon name="menu-outline" class="text-[24px]"></ion-icon>
    </div>
    <Teleport to="body">
        <Transition name="fade">
            <div
                v-if="isOpen"
                class="
                    fixed
                    top-0
                    left-0
                    w-full
                    h-full
                    bg-black bg-opacity-50
                    z-[101]
                    flex
                    items-start
                "
            >
                <section
                    :class="[
                        `w-[300px] bg-white h-full h-[100vh] flex flex-col duration-100 text-xs md:hidden overflow-y-scroll`,
                    ]"
                    id="mobile-app-sidebar"
                >
                    <img
                        :src="logo"
                        alt="Clipboard Nation Logo"
                        class="
                            w-[35%]
                            h-auto
                            mx-auto
                            mt-4
                            border-b-2
                            pb-6
                            border-gray-100
                        "
                    />
                    <div class="mt-4 mx-auto">
                        <div class="relative group h-28">
                            <img
                                :src="avatar"
                                alt="Avatar"
                                class="
                                    rounded-full
                                    w-max
                                    h-full
                                    mx-auto
                                    border-2 border-solid border-[#049DBF]
                                    aspect-square
                                    object-cover
                                "
                            />
                            <a
                                :href="profileHref"
                                class="
                                    absolute
                                    top-0
                                    left-0
                                    w-full
                                    h-full
                                    flex
                                    items-center
                                    justify-center
                                    bg-black bg-opacity-50
                                    rounded-full
                                    text-white
                                    transition-all
                                    opacity-0
                                    group-hover:opacity-100
                                    invisible
                                    group-hover:visible
                                    cursor-pointer
                                    backdrop-blur
                                "
                            >
                                Edit
                            </a>
                        </div>
                    </div>
                    <h1 class="text-center text-2xl font-bold mt-4 mb-4">
                        {{ name }}
                    </h1>
                    <slot class="my-8"></slot>
                </section>
                <button
                    @click="handleClose"
                    class="ml-4 mt-4 text-white text-xl"
                >
                    <ion-icon name="close"></ion-icon>
                </button>
            </div>
        </Transition>
    </Teleport>
</template>

<script>
export default {
    name: "MobileAppSidebar",
    props: [
        "avatar",
        "name",
        "logo",
        "logoSmall",
        "defaultCollapsed",
        "backHref",
        "profileHref",
    ],
    watch: {},
    mounted() {},
    data() {
        return {
            isOpen: false,
        };
    },
    methods: {
        handleOpen() {
            const scrollRoot = document.getElementById("scroll-root-element");
            this.isOpen = true;
            if (scrollRoot) {
                scrollRoot.style.overflowY = "hidden";
            }

            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "open-mobile-sidebar",
                    })
                );

                document
                    .querySelectorAll(".web-only-button")
                    .forEach((element) => {
                        element.style.display = "none";
                    });
            }
        },
        handleClose() {
            const scrollRoot = document.getElementById("scroll-root-element");
            this.isOpen = false;
            if (scrollRoot) {
                scrollRoot.style.overflowY = "auto";
            }
            if (window.ReactNativeWebView) {
                window.ReactNativeWebView.postMessage(
                    JSON.stringify({
                        action: "close-mobile-sidebar",
                    })
                );
            }
        },
    },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
</style>
